/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateCommitResponse {
    getFixupPrototypeFunction() { return TemplateCommitResponse.fixupPrototype; }

    static newInstance(model: Partial<TemplateCommitResponse>): TemplateCommitResponse {
        let obj = Object.assign(new TemplateCommitResponse(), model);
        TemplateCommitResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateCommitResponse>): TemplateCommitResponse {
        if (!model) return null;
        return TemplateCommitResponse.newInstance(<TemplateCommitResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateCommitResponse) {
        if (!obj) return;

        models.TemplateCommitResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateCommitResponse): boolean {
        Object.setPrototypeOf(obj, TemplateCommitResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Git commit reference for the pushed change
     */
    commit_id: string;

}
